import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CalendarAppointmentIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.1 1.9H16.15V0.95C16.15 0.38 15.77 0 15.2 0C14.63 0 14.25 0.38 14.25 0.95V1.9H4.75V0.95C4.75 0.38 4.37 0 3.8 0C3.23 0 2.85 0.38 2.85 0.95V1.9H0.95C0.475 1.9 0 2.28 0 2.85V16.15C0 16.72 0.475 17.1 0.95 17.1H6.745C6.08 15.96 5.7 14.63 5.7 13.3C5.7 9.12 9.12 5.7 13.3 5.7C15.105 5.7 16.72 6.365 18.05 7.41V2.85C18.05 2.375 17.575 1.9 17.1 1.9Z"
          fill="currentColor"
        />
        <path
          d="M13.3001 7.59961C10.1651 7.59961 7.60007 10.1646 7.60007 13.2996C7.60007 16.4346 10.1651 18.9996 13.3001 18.9996C16.4351 18.9996 19.0001 16.4346 19.0001 13.2996C19.0001 10.1646 16.4351 7.59961 13.3001 7.59961ZM15.2001 14.2496H13.3001C12.7301 14.2496 12.3501 13.8696 12.3501 13.2996V10.4496C12.3501 9.87961 12.7301 9.49961 13.3001 9.49961C13.8701 9.49961 14.2501 9.87961 14.2501 10.4496V12.3496H15.2001C15.7701 12.3496 16.1501 12.7296 16.1501 13.2996C16.1501 13.8696 15.7701 14.2496 15.2001 14.2496Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

CalendarAppointmentIcon.displayName = 'CalendarAppointmentIcon'
